import type { ReactNode } from 'react'

import { Button } from '@/components/ui/clickable/Button'
import { Loader } from '@/components/ui/Loader'
import type { CloudSource } from '@/modules/upload/cloud/types'
import type { AddFiles } from '@/modules/upload/types'
import { useCloudImport } from './useCloudImport'

export interface ProviderImportButtonProps {
  addFiles: AddFiles
  onImportChange?: (isImporting: boolean) => void
  disabled?: boolean
}

interface CloudImportButtonProps extends ProviderImportButtonProps {
  source: CloudSource
  icon: ReactNode
}

export const CloudImportButton = ({
  source,
  icon,
  addFiles,
  onImportChange,
  disabled,
}: CloudImportButtonProps) => {
  const { stage, failureNotices, pickFiles } = useCloudImport({
    source,
    addFiles,
    onImportChange,
  })
  return (
    <div className="flex flex-col gap-1 sm:flex-1 sm:basis-0">
      <Button
        theme="outline"
        size="sm"
        className="w-full justify-center"
        onClick={pickFiles}
        disabled={disabled || stage !== 'idle'}
        isLoading={stage === 'getting-files'}
        loadingText={`Getting files from ${source.label}`}
      >
        {stage === 'choosing' ? <Loader /> : icon}
        Upload from {source.label}
      </Button>
      {failureNotices.map(({ id, message }) => (
        <p key={id} className="text-sm text-red-600" role="alert">
          {message}
        </p>
      ))}
    </div>
  )
}
